import { useMemo } from 'react'
import { filterStoreRepo } from 'components/Filters/FilterStore'
import { MobileFilterGroup } from 'components/Filters/components/FilterModal'
import { FilterIdentifier } from 'models/saved_view'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import type { SelectFilterOption } from 'components/Filters/fields/SelectFilter'
import { DateRangeFilterWithPresets } from 'components/Filters/fields/DateRangeFilterWithPresets'
import { useGetUserOptions, useGetProductsOptions } from 'services/samples'

const STATUS_OPTIONS = [
  { value: 'submitted', label: 'Submitted' },
  { value: 'cancelled', label: 'Cancelled' },
]

const FULFILLMENT_OPTION_OPTIONS = [
  { value: 'pick_up_locally', label: 'Pick-Up Locally' },
  { value: 'ship_to_address', label: 'Ship to Shipping Address' },
]

export function MobileSamplesFilterset({
  filterIdentifier,
}: {
  filterIdentifier: FilterIdentifier
}) {
  const samplesFilterStore = filterStoreRepo.getStore(filterIdentifier)

  // Fetch filter options
  const { data: rawUserOptions } = useGetUserOptions({
    onlyActive: true,
    withNoneOption: false,
  })

  const { data: rawProductOptions } = useGetProductsOptions(true)

  // Transform to SelectFilterOption format (string values)
  const userOptions: SelectFilterOption[] | undefined = useMemo(() => {
    return rawUserOptions?.map((option) => ({
      ...option,
      value: String(option.value),
    }))
  }, [rawUserOptions])

  const productOptions: SelectFilterOption[] | undefined = useMemo(() => {
    return rawProductOptions?.map((option) => ({
      ...option,
      value: String(option.value),
    }))
  }, [rawProductOptions])

  return (
    <>
      <MobileFilterGroup title="Order Status">
        <SelectFilter
          title="Status"
          filterKey="status"
          filterStore={samplesFilterStore}
          options={STATUS_OPTIONS}
        />
        <SelectFilter
          title="Fulfillment Option"
          filterKey="fulfillment_option"
          filterStore={samplesFilterStore}
          options={FULFILLMENT_OPTION_OPTIONS}
        />
      </MobileFilterGroup>

      <MobileFilterGroup title="Requestor & Product">
        <SelectFilter
          title="Requestor"
          filterKey="requestor"
          filterStore={samplesFilterStore}
          options={userOptions || []}
        />
        <SelectFilter
          title="Product"
          filterKey="product"
          filterStore={samplesFilterStore}
          options={productOptions || []}
        />
      </MobileFilterGroup>

      <MobileFilterGroup title="Date Filters">
        <DateRangeFilterWithPresets
          title="Date Needed"
          filterKey="date_needed"
          filterStore={samplesFilterStore}
        />
        <DateRangeFilterWithPresets
          title="Date Created"
          filterKey="created"
          filterStore={samplesFilterStore}
        />
      </MobileFilterGroup>
    </>
  )
}
